import { createFileRoute } from '@tanstack/react-router';

import { ConfirmEmailPage } from '../../pages/auth';

export const Route = createFileRoute('/auth/confirm-email')({
  validateSearch: (search: Record<string, unknown>): { token: string } => ({
    token: typeof search.token === 'string' ? search.token : '',
  }),
  component: () => <ConfirmEmailPage token={Route.useSearch().token} />,
});
